import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ project, report }) =>
    present(
      repository
        .saveProjectReport(project, report)
        .then((savedReport) => ({ project, report: savedReport }))
        .catch(() =>
          Promise.reject({
            project,
            report,
          }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
